import React from "react";

const OoraInfraMetaFields = ({ form, onChange, disabled }) => (
  <>
    <div className="oid-field">
      <label className="oid-label">Title <span className="oid-req">*</span></label>
      <input
        className="oid-input"
        type="text"
        name="title"
        value={form.title}
        onChange={onChange}
        placeholder="e.g. Noida Sector 150"
        disabled={disabled}
      />
    </div>

    <div className="oid-field">
      <label className="oid-label">Description <span className="oid-optional">(Optional)</span></label>
      <textarea
        className="oid-input oid-textarea"
        name="description"
        value={form.description}
        onChange={onChange}
        placeholder="Describe this dataset"
        rows={3}
        disabled={disabled}
      />
    </div>

    <div className="oid-field">
      <label className="oid-label">Research Methodology <span className="oid-optional">(Optional)</span></label>
      <textarea
        className="oid-input oid-textarea"
        name="research_methodology"
        value={form.research_methodology}
        onChange={onChange}
        placeholder="How was this data collected?"
        rows={3}
        disabled={disabled}
      />
    </div>

    <div className="oid-grid-2">
      <div className="oid-field">
        <label className="oid-label">Date <span className="oid-optional">(Optional)</span></label>
        <input className="oid-input" type="date" name="date" value={form.date} onChange={onChange} disabled={disabled} />
      </div>
      <div className="oid-field">
        <label className="oid-label">Year <span className="oid-optional">(Optional)</span></label>
        <input
          className="oid-input"
          type="number"
          name="year"
          value={form.year}
          onChange={onChange}
          placeholder="e.g. 2024"
          min="1900"
          max="2100"
          disabled={disabled}
        />
      </div>
      <div className="oid-field">
        <label className="oid-label">Start Date <span className="oid-optional">(Optional)</span></label>
        <input
          className="oid-input"
          type="date"
          name="start_date"
          value={form.start_date}
          max={form.end_date || undefined}
          onChange={onChange}
          disabled={disabled}
        />
      </div>
      <div className="oid-field">
        <label className="oid-label">End Date <span className="oid-optional">(Optional)</span></label>
        <input
          className="oid-input"
          type="date"
          name="end_date"
          value={form.end_date}
          min={form.start_date || undefined}
          onChange={onChange}
          disabled={disabled}
        />
      </div>
    </div>

    <div className="oid-field">
      <label className="oid-label">Source Link <span className="oid-optional">(Optional)</span></label>
      <input
        className="oid-input"
        type="url"
        name="source_link"
        value={form.source_link}
        onChange={onChange}
        placeholder="https://example.com/source"
        disabled={disabled}
      />
    </div>

    <div className="oid-field">
      <label className="oid-label">Note <span className="oid-optional">(Optional)</span></label>
      <textarea
        className="oid-input oid-textarea"
        name="note"
        value={form.note}
        onChange={onChange}
        placeholder="Any additional notes"
        rows={2}
        disabled={disabled}
      />
    </div>
  </>
);

export default OoraInfraMetaFields;